import TLogin from './index.vue';

TLogin.install = app => {
  app.component(TLogin.name, TLogin);
};

export default TLogin;
